import { module } from 'modujs';
const axios = require('axios').default;

export default class extends module {

    constructor(m) {
        super(m);
        this.form = this.$( 'form' )[0];
        this.form.addEventListener( 'submit', this.onSubmit.bind( this ) );
        this.message = this.$( 'message' )[0];
    }

    onSubmit( ev ){
        ev.preventDefault();
        this.form.classList.add( 'loading');
        axios.post( THEME_OBJ.ajaxURL, new FormData( this.form ) ).then( this.onResponse.bind( this )).catch( this.onError.bind( this ) );
    }

    onResponse(response){
        this.message.textContent = response.data.message;
        this.form.classList.remove( ...['pointer-events-none', 'loading']);
        this.form.classList.add( response.data.success ? 'sent' : 'failed' );
        response.data.success ? this.onSuccess() : this.onError();

    }

    onSuccess( ){
        this.form.reset();
        [ ...this.form.querySelectorAll( '.is-focused') ].forEach( el => el.classList.remove( 'is-focused' ) );
        this.resetMessages( 3000 );
        setTimeout( () => this.$( 'close' )[0].click(), 2000 )
    }

    onError(){
        this.form.classList.remove( ...['pointer-events-none', 'loading']);
        this.resetMessages();

    }

    resetMessages( delay = 2000 ){
        setTimeout( () => {
            this.form.classList.remove( ...['sent', 'failed']);
            this.message.textContent = '';
        }, delay );
    }

}
